import React from 'react';
import PropTypes from 'prop-types';

const Loading = ({ children, label }) => (
  <div>
    <div
      style={{
        position: 'absolute',
        top: '0',
        right: '0',
        left: '0',
        bottom: '0',
        background: '#fff7',
        zIndex: '5',
        padding: '2%',
        textAlign: 'center',
      }}
    >
      <div>{ label }</div>
    </div>
    { children }
  </div>
);

Loading.propTypes = {
  children: PropTypes.instanceOf(Object),
  label: PropTypes.string,
};

Loading.defaultProps = {
  label: '',
  children: null,
};

export default Loading;
